import { useEffect, useRef } from "react";
import { useI18n } from "@/i18n";

export default function About() {
  const { t } = useI18n();
  const artworkRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const artwork = artworkRef.current;
    if (!artwork) return;

    const media = window.matchMedia("(max-width: 960px)");
    let animationFrame = 0;
    const updateColour = () => {
      if (!media.matches) {
        artwork.style.removeProperty("--artwork-grayscale");
        return;
      }

      const { top } = artwork.getBoundingClientRect();
      const start = window.innerHeight * 0.88;
      const end = window.innerHeight * 0.34;
      const progress = Math.min(1, Math.max(0, (start - top) / (start - end)));
      artwork.style.setProperty("--artwork-grayscale", `${Math.round((1 - progress) * 100)}%`);
    };
    const scheduleUpdate = () => {
      cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(updateColour);
    };

    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.addEventListener("resize", scheduleUpdate);
    media.addEventListener("change", scheduleUpdate);
    scheduleUpdate();
    return () => {
      cancelAnimationFrame(animationFrame);
      window.removeEventListener("scroll", scheduleUpdate);
      window.removeEventListener("resize", scheduleUpdate);
      media.removeEventListener("change", scheduleUpdate);
    };
  }, []);

  return (
    <div className="page-shell about-page">
      <section className="container page-hero about-hero">
        <div className="about-content">
          <span className="eyebrow">{t.about.title}</span>
          <h1 className="sr-only">{t.about.title}</h1>
          <div className="about-section-copy about-copy">
            <p className="about-name">{t.about.subtitle}</p>
            <p>{t.about.intro}</p>
            <p>{t.about.invitation}</p>
          </div>
          <blockquote className="about-quote">
            <p>“{t.about.quote}”</p>
            <footer>— {t.about.quoteAuthor}</footer>
          </blockquote>
        </div>
        <figure className="about-artwork-image" ref={artworkRef}>
          <img src="/images/hero-artwork.jpg" alt={t.about.artworkAlt} />
        </figure>
      </section>
    </div>
  );
}
